const mapEnvironment = {
  localhost: {
    AUTH: "https://services-hmg.btcorretora.com.br/casproxy",
    API: "https://services-hmg.btcorretora.com.br/easywayapp",
    CADASTRO: "https://services-hmg.btcorretora.com.br/apicadastro",
    APPROVAL: "http://api-procamplus-hmg.btcorretora.intranet/approvals",
    KEYCLOAK: "https://keycloak-dev.btcorretora.com.br/auth/realms/ProcamDev/protocol/openid-connect",
    CLIENT_SECRET_APPROVAL: "2jn0MNSI2GHmYAMdmvfxuMVQPsHOmA2X"
  },
  "sistemas-dev.btcorretora.extranet": {
    AUTH: "https://services-hmg.btcorretora.com.br/casproxy",
    API: "https://services-hmg.btcorretora.com.br/easywayapp",
    CADASTRO: "https://services-hmg.btcorretora.com.br/apicadastro",
    APPROVAL: "http://api-procamplus-hmg.btcorretora.intranet/approvals",
    KEYCLOAK: "https://keycloak-hmg.btcorretora.com.br/auth/realms/ProcamHmg/protocol/openid-connect",
    CLIENT_SECRET_APPROVAL: "2jn0MNSI2GHmYAMdmvfxuMVQPsHOmA2X"
  },
  "sistemas-hmg.btcorretora.com.br": {
    AUTH: "https://services-hmg.btcorretora.com.br/casproxy",
    API: "https://services-hmg.btcorretora.com.br/easywayapp",
    CADASTRO: "https://services-hmg.btcorretora.com.br/apicadastro",
    APPROVAL: "http://api-procamplus-hmg.btcorretora.intranet/approvals",
    KEYCLOAK: "https://keycloak-hmg.btcorretora.com.br/auth/realms/ProcamHmg/protocol/openid-connect",
    CLIENT_SECRET_APPROVAL: "Ow67f4CAjd29Cd23ffNEzVcTcMWbRj7v"
  },
  "sistemas-hmg.btcorretora.extranet": {
    AUTH: "https://services-hmg.btcorretora.com.br/casproxy",
    API: "https://services-hmg.btcorretora.com.br/easywayapp",
    CADASTRO: "https://services-hmg.btcorretora.com.br/apicadastro",
    APPROVAL: "http://api-procamplus-hmg.btcorretora.intranet/approvals",
    KEYCLOAK: "https://keycloak-hmg.btcorretora.com.br/auth/realms/ProcamHmg/protocol/openid-connect",
    CLIENT_SECRET_APPROVAL: "Ow67f4CAjd29Cd23ffNEzVcTcMWbRj7v"
  },
  "cadastro.btcorretora.com.br": {
    AUTH: "https://servicescasproxy.btcorretora.com.br/casproxy",
    API: "https://serviceseasyway.btcorretora.com.br/easywayapp",
    CADASTRO: "https://serviceseasyway.btcorretora.com.br/apicadastro",
    APPROVAL: "http://api-procamplus.btcorretora.intranet/approvals",
    KEYCLOAK: "https://keycloak.btcorretora.com.br/auth/realms/Procam/protocol/openid-connect",
    CLIENT_SECRET_APPROVAL: "siPR9o6i4oGe2vY6qdNBCJCCYwaAQU9t"
  },
};

export default {
  appId: "6E854149-D837-4581-97E3-8D1666B30E58",
  appKey: "DE39E3E8-7689-40E6-95BD-C3D22F49F0C2",
  username: "cadastro-api",
  password: "T@rget00!%",
  usernameQuotation: "site-institucional",
  passwordQuotation: "T@rget00!%",
  storageAuthName: "AuthCadastroWebBT",
  storageAuthNameQuotation: "AuthQuotationBT",
  clientIdApproval: "app-api-approval",
  clientSecretApproval: mapEnvironment[window.location.hostname].CLIENT_SECRET_APPROVAL,
  storageAuthNameApproval: "AuthApprovalBT",
  baseAuthURL: mapEnvironment[window.location.hostname].AUTH,
  baseAuthURLKeycloak: mapEnvironment[window.location.hostname].KEYCLOAK,
  baseURL: mapEnvironment[window.location.hostname].API,
  baseURLCadastro: mapEnvironment[window.location.hostname].CADASTRO,
  baseURLApproval: mapEnvironment[window.location.hostname].APPROVAL,
};
